import StatisticInfoModal from './StatisticInfoModal'

export default StatisticInfoModal
